// extracted by mini-css-extract-plugin
export var containerVideo = "Video-module--containerVideo--8KVns";
export var poster = "Video-module--poster--XgfzD";
export var video = "Video-module--video--UhGHm";
export var wrapper = "Video-module--wrapper--QcTWl";